import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Assets
import arrowIcon from "../../assets/previous_icon.png";
import editIcon from "../../assets/edit_icon.png";

// Utils
import useLanguage from "../../utils/useLanguage";

// Components
import InformationBox from "../../components/InformationBox";
import CustomButton from "../../components/CustomButton";
import CopyButton from "../../components/CopyButton";

const PaperTable = ({ data, onEditRuler, collapsed, setCollapsed }) => {
  const { currentDirection } = useLanguage();
  const { t } = useTranslation("general");

  const toggleCollapse = (fabricCode) => {
    setCollapsed((prev) => ({
      ...prev,
      [fabricCode]: !prev[fabricCode],
    }));
  };

  useEffect(() => {
    setCollapsed((prev) => {
      const updated = { ...prev };
      data.forEach((fabric) => {
        if (updated[fabric.id] === undefined) {
          updated[fabric.id] = true;
        }
      });
      return updated;
    });
  }, [data]);

  return (
    <div
      className="c-fabric-table o-column o-column--gap-size_400 u-margin u-margin--bottom_700"
      dir={currentDirection}
    >
      {data.length === 0 ? (
        <InformationBox>{t("noCategoriesFound")}</InformationBox>
      ) : null}
      {data.map((fabric) => (
        <div className="" key={fabric.id}>
          <div className="c-fabric-block">
            <div
              className="c-fabric-header o-row--horizontal-align_space-between"
              onClick={() => toggleCollapse(fabric.id)}
            >
              <div className="o-row">
                <span className="c-collapse-icon" style={{ cursor: "pointer" }}>
                  <img
                    src={arrowIcon}
                    alt="Collapse"
                    style={{
                      width: 16,
                      transform: collapsed[fabric.id]
                        ? "rotate(0deg)"
                        : "rotate(-90deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </span>
                <div className="o-column o-column--gap-size_200">
                  <span className="c-fabric-code">
                    {t("uniformName")}: {fabric.name}
                  </span>
                  <span className="c-fabric-code">
                    {t("color")}: {fabric.color}
                  </span>
                </div>
              </div>
              <CustomButton
                title={t("edit")}
                variant="blank"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditRuler(fabric);
                }}
                icon={editIcon}
                iconSize={18}
              />
            </div>

            {!collapsed[fabric.id] && (
              <table className="c-fabric-inner-table">
                <thead>
                  <tr>
                    <th>{t("size")}</th>
                    <th>{t("theCount")}</th>
                    <th>{t("singlePurchasePrice")}</th>
                    <th>{t("singleSellPrice")}</th>
                  </tr>
                </thead>
                <tbody>
                  {fabric.sizes.map((size) => (
                    <tr key={size.colorCode}>
                      <td className="o-row o-row--horizontal-align_center o-row--vertical-align_center o-row--gap-size_400">
                        <CopyButton text={size?.name} />
                        <Link to={`/product-page/${size?.id}?type=uniform`}>
                          {size?.size}
                        </Link>
                      </td>
                      <td>{size?.quantity}</td>
                      <td>{size?.purchasePrice}</td>
                      <td>{size?.sellPrice}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
export default PaperTable;
